// Dependencies

const initialState = {
  lastSearch: '',
  language: '',
  typeSearch: '',
  lastRow: null,
  renewSessionFormVisibility: false,
};

const mutations = {
  SET_LAST_SEARCH: (state, lastSearch) => {
    state.lastSearch = lastSearch;
  },
  SET_TYPE_SEARCH: (state, typeSearch) => {
    state.typeSearch = typeSearch;
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
  },
  SET_LAST_ROW: (state, row) => {
    state.lastRow = row;
  },
  SET_RENEW_SESSION_FORM_VISIBILITY: (state, visibility) => {
    state.renewSessionFormVisibility = visibility;
  },
};

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language);
  },
  setLastSearch({ commit }, lastSearch) {
    commit('SET_LAST_SEARCH', lastSearch);
  },
  setTypeSearch({ commit }, typeSearch) {
    commit('SET_TYPE_SEARCH', typeSearch);
  },
  setLastRow({ commit }, row) {
    commit('SET_LAST_ROW', row);
  },
  setRenewSessionFormVisibility({ commit }, visibility) {
    commit('SET_RENEW_SESSION_FORM_VISIBILITY', visibility);
  },
};

const getters = {
  language: (state) => state.language,
  lastSearch: (state) => state.lastSearch,
  typeSearch: (state) => state.typeSearch,
};

export default {
  state: initialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
